// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Resource from 'vue-resource'

import App from './App'
import store from './store'
import router from './router'
import filters from './filters'
import './assets/less/app.less'
import Navbar from '@/components/blocks/navbar'
import Pagination from '@/components/blocks/pagination'
import VerifyCode from '@/components/blocks/verify-code'

import Global from './global'

import {
  mapActions,
  mapGetters
} from 'vuex'

Vue.config.productionTip = false
Vue.prototype.global = Global

Vue.use(Resource)
import './resource/interceptor.js'

Vue.component('navbar', Navbar)
Vue.component('pagination', Pagination)
Vue.component('verify-code', VerifyCode)
for (let prop in filters) {
  Vue.filter(prop, filters[prop])
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  filters,
  template: '<App/>',
  components: {
    App
  },
  computed: {
    ...mapGetters({
      'user': 'loginUser'
    })
  },
  created: function () {
    // this.session()
  },
  watch: {
    // '$route': 'session'
  },
  methods: {
    ...mapActions({
      'session': 'getSession'
    })
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js